export default __webpack_public_path__ + "static/customer-aea9dc6f0909acde48cf2ea533af2b1b.jpg";